import { ReactNode, memo } from 'react';
import styled from '@emotion/styled';
import { zIndex } from 'presentations/views/styles';
import SnackbarContent from '@mui/material/SnackbarContent';
import { black, white } from 'presentations/views/styles/color';
import Backdrop from '@mui/material/Backdrop';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import Fade from '@mui/material/Fade';
import { TransitionProps } from '@mui/material/transitions';
import Progress from '../Progress';

interface Props {
  isOpen: boolean;
  children?: ReactNode;
  message?: string;
}

// export default function Component(props: Props) {
//   return (
//     <StyledBackdrop open={props.isOpen}>
//       <Snackbar isOpen={true} isLoading={true} message={props.message} />
//     </StyledBackdrop>
//   );
// }
const Component = memo((props: Props) => {
  function SlideTransition(props: TransitionProps | any) {
    if (props.in) {
      return <Slide {...props} direction="down" />;
    } else {
      return <Fade {...props} />;
    }
  }

  return (
    <StyledBackdrop open={props.isOpen}>
      <LoadingSnackbar
        TransitionComponent={SlideTransition}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={props.isOpen}
      >
        <LoadingContent
          message={
            <LoadingContainer>
              <Progress color="primary" variant="indeterminate" size={32} />
            </LoadingContainer>
          }
        />
      </LoadingSnackbar>
    </StyledBackdrop>
  );
});

const StyledBackdrop = styled(Backdrop)`
  z-index: ${zIndex(800)};
  color: ${white};
  background-color: rgba(255, 255, 255, 0);
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingSnackbar = styled(Snackbar)`
  top: 96px;
`;
const LoadingContent = styled(SnackbarContent)`
  background-color: ${white};
  color: ${black};
  border-radius: 50%;
  min-width: 64px !important;
  width: 64px;
  height: 64px;
  min-height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.05);
`;

export default Component;
